<template>
  <div class="flex md12">
    <div class="row row-inside">
      <div class="flex md12">
        <div class="row row-inside">
          <h6 class="mr-2">{{ $t("gestionAdhesion.onpftitle") }}</h6>

          <va-badge :color="unpfStatuts">{{
            getStatutsText(unpfStatuts)
          }}</va-badge>

          <h6 class="ml-4 mr-2">{{ $t("gestionAdhesion.speftitle") }}</h6>
          <va-badge :color="spefStatuts">{{
            getStatutsText(spefStatuts)
          }}</va-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isEqual } from "lodash";
import axios from "axios";

export default {
  name: "adhesionManager",
  props: ["identreprise", "toupdate"],

  data() {
    return {
      dateCompare: new Date(),
      adhesionSpef: this.resetAdhesion(2),
      adhesionUnpf: this.resetAdhesion(1),
      adhesionSpefOrigin: this.resetAdhesion(2),
      adhesionUnpfOrigin: this.resetAdhesion(1),
      simple: null,
      paiementAmount: null,
      infoUnpfUpdated: false,
      infoSpefUpdated: false,
      statusAdh: {
        unpfDirect: false,
        spefDirect: false,
        unpfLinked: false,
        spefLinked: false
      }
    };
  },
  computed: {
    spefStatuts: function() {
      return this.getStatuts(this.adhesionSpef);
    },
    unpfStatuts: function() {
      return this.getStatuts(this.adhesionUnpf);
    },
    opefStatuts: function() {
      if (
        (this.spefStatuts && this.spefStatuts === "success") ||
        (this.unpfStatuts && this.unpfStatuts === "success")
      )
        return "success";

      if (
        (this.spefStatuts && this.spefStatuts === "info") ||
        (this.unpfStatuts && this.unpfStatuts === "info")
      )
        return "info";
      if (this.spefStatuts === "warning" || this.unpfStatuts === "warning")
        return "warning";
      return "danger";
    }
  },
  mounted() {},
  methods: {
    getStatuts(adhesion) {
      if (!adhesion.date_fin) {
        if (
          adhesion.syndicat_idsyndicat &&
          ((adhesion.syndicat_idsyndicat == 2 && this.statusAdh.spefLinked) ||
            (adhesion.syndicat_idsyndicat == 1 && this.statusAdh.unpfLinked))
        ) {
          return "info";
        } else {
          return "danger";
        }
      }

      let t = adhesion.date_fin.split("-");
      let dateFin = new Date(t[0], t[1] - 1, t[2]);

      if (dateFin > this.dateCompare) {
        return "success";
      } else {
        return "warning";
      }
    },
    getStatutsText(statut) {
      if (statut === "success") return "Adhérent";
      if (statut === "warning") return "Expiré";
      if (statut === "info") return "Adhésion liée";
      return "Non adhérent";
    },
    async loadAdhesions(id) {
      try {
        let responseStatus = await axios.get("/api/adhesions-opef-entreprise", {
          params: {
            id: id
          }
        });
        let adhesionList = responseStatus.data.list;
        this.statusAdh = responseStatus.data.status;
        console.log(this.statusAdh);
        if (adhesionList.length === 0) {
          this.adhesionSpef = this.resetAdhesion(2);
          this.adhesionUnpf = this.resetAdhesion(1);
          this.adhesionSpefOrigin = this.resetAdhesion(2);
          this.adhesionUnpfOrigin = this.resetAdhesion(1);
        }
        let unpfDone = false;
        let spefDone = false;
        adhesionList.forEach(element => {
          if (element.syndicat_idsyndicat === 1 && !unpfDone) {
            this.adhesionUnpf = cloneDeep(element);
            this.adhesionUnpfOrigin = cloneDeep(element);
          }

          if (element.syndicat_idsyndicat === 2 && !spefDone) {
            this.adhesionSpef = cloneDeep(element);
            this.adhesionSpefOrigin = cloneDeep(element);
          }
        });
      } catch (error) {
        // console.log(error);
      }
    },
    resetAdhesion(idsyndicat) {
      let rep = {
        idadhesion: null,
        date_adhesion: null,
        date_renouvellement: null,
        isactif: null,
        entreprise_identreprise: this.identreprise,
        syndicat_idsyndicat: idsyndicat,
        cotisation_paye: null
      };
      return rep;
    },

    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  },
  watch: {
    adhesionUnpf: {
      deep: true,
      handler() {
        if (!isEqual(this.adhesionUnpf, this.adhesionUnpfOrigin)) {
          this.$emit("infosChanged", true);
          this.infoUnpfUpdated = true;
        } else {
          this.$emit("infosChanged", false);
          this.infoUnpfUpdated = false;
        }
      }
    },
    adhesionSpef: {
      deep: true,
      handler() {
        if (!isEqual(this.adhesionSpef, this.adhesionSpefOrigin)) {
          this.$emit("infosChanged", true);
          this.infoSpefUpdated = true;
        } else {
          this.$emit("infosChanged", false);
          this.infoSpefUpdated = false;
        }
      }
    },
    opefStatuts(newstatus) {
      this.$emit("opefStatuts", newstatus);
    },
    identreprise(newid) {
      if (newid) {
        this.loadAdhesions(newid);
      }
      this.dateCompare = new Date();
    },
    toupdate(newValue) {
      if (newValue) {
        this.loadAdhesions(this.identreprise);
        this.$emit("updatedone");
      }
    }
  }
};
</script>

<style lang="scss">
.padded-right {
  padding-right: 1%;
}
.padded-left {
  padding-left: 1%;
}
.forcewidth {
  min-width: 80vw;
}
</style>
